import { render, staticRenderFns } from "./CardsUpload.vue?vue&type=template&id=1b996dec&"
import script from "./CardsUpload.vue?vue&type=script&lang=js&"
export * from "./CardsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports